import React from 'react';
import Footer from 'src/layouts/Footer';

const ErrorLayout = ({ children }) => {
  return (
    <div id="err">
      <div>
        <div className="err">{children}</div>
      </div>
      <Footer />
    </div>
  );
};

export default ErrorLayout;
